import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './aiResponseFileRender.module.scss';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { ReactComponent as CircleDownIcon } from 'v2/icons/circle-down.svg';

type AIResponseFileRenderProps = {
  href: string;
  children: React.ReactNode;
};

const AIResponseFileRender = ({
  href,
  children,
}: AIResponseFileRenderProps) => {
  return (
    <Button
      variant="link"
      className={classnames('d-inline p-0', styles.aiFileButton)}
      onClick={() => window.open(href, '_blank')}
      data-testid="downloadButton"
    >
      {children}
      <CircleDownIcon className={styles.downloadIcon} />
    </Button>
  );
};

export default AIResponseFileRender;
